import { instantsInterceptor, } from '@/api/index';

function getControllerTypeList() {
    return instantsInterceptor.get('/mgmt/controllerType/list');
}

function changeControllerTypeUse(form) {
    return instantsInterceptor.post('/mgmt/controllerType/changeUse', form);
}

function checkControllerTypeNameDuplication(form) {
    return instantsInterceptor.post('/mgmt/controllerType/check', form);
}

function getControllerType(id) {
    return instantsInterceptor.get('/mgmt/controllerType/updateForm/' + id);
}

function addControllerType(form) {
    return instantsInterceptor.post('/mgmt/controllerType/form', form);
}

function update(form) {
    return instantsInterceptor.post('/mgmt/controllerType/update', form);
}

function deleteControllerType(form){
    return instantsInterceptor.post('/mgmt/controllerType/delete', form);
}

function updateControllerOrder(form) {
    return instantsInterceptor.post('/mgmt/controllerType/changeOrder', form);
}

export { getControllerTypeList, changeControllerTypeUse,
     checkControllerTypeNameDuplication, getControllerType, 
     addControllerType, update, 
     deleteControllerType, updateControllerOrder};